import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { LookupData } from '../models/lookup';
import { map } from 'rxjs/operators';
import { ApiResult } from '../models/ApiResult';




@Injectable()
export class ClientesService {

  myAppUrl = '';

  constructor(private _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  getClientes() {
    return this._http.get(this.myAppUrl + 'api/Clientes/');
  }

  getClientesLookup(searchTerm: string): Observable<LookupData> {
    return this._http.get<LookupData>(this.myAppUrl + 'api/Clientes/Lookup?k=' + searchTerm);
  }

  getClientesLookupId(id: number): Observable<LookupData> {
    return this._http.get<LookupData>(this.myAppUrl + 'api/Clientes/Lookup/' + id.toString());
  }

  getClientesFiltered(searchTerm: string) {
    return this._http.get(this.myAppUrl + 'api/Clientes?k=' + searchTerm);
  }

  getClientesPaged(searchTerm: string, startRow: number, endRow: number, filterModel?: any, sortModel?: any[]): Observable<{ rows: any[], totalCount: number }> {
    let url = this.myAppUrl + 'api/Clientes?startRow=' + startRow + '&endRow=' + endRow;
    if (searchTerm) {
      url += '&k=' + encodeURIComponent(searchTerm);
    }
    if (filterModel && Object.keys(filterModel).length > 0) {
      url += '&filterModel=' + encodeURIComponent(JSON.stringify(filterModel));
    }
    if (sortModel && sortModel.length > 0) {
      url += '&sortModel=' + encodeURIComponent(JSON.stringify(sortModel));
    }
    return this._http.get<{ rows: any[], totalCount: number }>(url);
  }

  getClienteID(id:number) {
    return this._http.get(this.myAppUrl + 'api/Clientes/' + id);
  }

  postCliente(cliente): Observable<ApiResult> {
    return this._http.post<ApiResult>(this.myAppUrl + 'api/Clientes/', cliente);
  }

  updateCliente(id:number, cliente): Observable<ApiResult> {
    return this._http.put<ApiResult>(this.myAppUrl + 'api/Clientes/' + id, cliente);
  }

  removeCliente(id:number): Observable<ApiResult> {
    return this._http.delete<ApiResult>(this.myAppUrl + 'api/Clientes/' + id);
  }

}
